import router from './router';
import Vue from 'vue'
import Router from 'vue-router'
// import { Message } from 'element-ui'
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import {getToken, getUserName, getLoginType} from '@/utils/auth'; // getToken from cookie
import {reloadStore} from '@/utils/store';
import {constantRoutes, asyncRoutes, asyncRoutesManage} from '@/router';
import {doJsonPost, doFormPost,doJsonGet} from '@/utils/request';
import store from './store/index';
import routerList from './router/routerList'

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) {
    // admin permission passed directly
    return true;
  }
  if (!permissionRoles) {
    return true;
  }
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

/**
 * 是否有某路径的权限
 * @param {object} routers 全部的路由
 * @param {object} to 当前要跳转的路由
 */
function hasPathPermission(routers, to) {
  var components = routers.getMatchedComponents(to);
  if (components && components.length > 0) {
    return true;
  } else {
    return false;
  }
}
var flag = false;
/**
 * no redirect whitelist
 */
const whiteList = ['/login', '/shopping-mall/marketing-tools'];

/**
 * 把基于回调的 doFormPost 包装成 Promise
 * 无论成功或失败都 resolve，失败时 resolve(null)，便于链式调用时不进入 reject 分支
 * @param {string} url 接口地址
 * @param {object} data 入参
 * @returns {Promise<object>} 接口返回数据（失败时为 null）
 */
function fetchFormPost(url, data) {
  return new Promise(resolve => {
    doFormPost(url, data, rs => {
      resolve(rs);
    }, () => {
      resolve(null);
    });
  });
}

/**
 * 调用 getStoreType 获取店铺基础信息
 * 成功时返回 rs，失败时返回 null
 *
 * 账号切换检测：
 *   - 比较新返回的 userCode 与 vuex.brandConfig.userCode（来自 localStorage 缓存）
 *   - 若不一致，说明浏览器切换了账号（同浏览器多账号场景），先清除旧 brandConfig
 *   - 避免 initialBrandConfig 加载到上一个账号的品牌标志
 *
 * @returns {Promise<object|null>}
 */
function fetchStoreInfo() {
  return fetchFormPost('/main/getStoreType', null).then(rs => {
    if (rs && rs.result === 'success') {
      const newUserCode = rs.userData.userCode;
      const cachedUserCode = store.state.app.brandConfig.userCode;
      // 检测账号切换：缓存中有旧 userCode 且与新 userCode 不一致
      // 此时 vuex.brandConfig 是从 localStorage 加载的旧账号配置，必须先清掉
      if (cachedUserCode && newUserCode && cachedUserCode !== newUserCode) {
        console.warn('[brandConfig] 检测到账号切换，清除旧 brandConfig 缓存', {
          old: cachedUserCode,
          new: newUserCode
        });
        store.dispatch('resetBrandConfig');
      }
      // 同步写入 vuex
      store.dispatch('setStoreType', rs.userData.storeType);
      store.dispatch('setNickName', rs.userData.nickName);
      store.dispatch('setHeadImgUrl', rs.userData.headImgUrl);
      store.dispatch('setOpenId', rs.userData.openId);
      store.dispatch('setShopId', rs.userData.shopId);
      store.dispatch('setToken', rs.userData.token);
      store.dispatch('setUserCode', rs.userData.userCode);
      return rs.userData;
    }
    return null;
  });
}

/**
 * 调用 getShopBrandConfig 获取店铺品牌配置
 * 成功时返回 brandConfig 并同步写入 vuex（含 isHaidilao/isDanBo/isxjch/isZhongfu 顶层属性）
 * 失败时返回 null
 * @returns {Promise<object|null>}
 */
function fetchBrandConfig() {
  return fetchFormPost('/main/getShopBrandConfig', null).then(brandRs => {
    if (brandRs && brandRs.result === 'success' && brandRs.userData) {
      // 把当前 userCode 和登录时间戳也写入 brandConfig，便于下次账号切换检测
      const userData = Object.assign({}, brandRs.userData, {
        userCode: store.state.app.userCode || '',
        loginTime: Date.now()
      });
      // setBrandConfig 内部会同步 isHaidilao/isDanBo/isxjch/isZhongfu 到 state 顶层
      // 并自动持久化到 localStorage，保证刷新后不丢失
      store.dispatch('setBrandConfig', userData);
      return userData;
    }
    return null;
  });
}

/**
 * 根据 storeType 加载路由并跳转
 */
function proceedRoutes(storeType, to, next) {
  //currency 通用商城  exclusive  专属商城  cloudCooperation 云协作商城 rzGroupBuy 如琢团购 hcy移动和彩云
  if (storeType === 'cloudCooperation') {
    router.addRoutes(routerList.cloudCooperation);
    document.title = '如琢毕业册';
  } else if(storeType === 'rzGroupBuy'){
    router.addRoutes(routerList.rzGroupBuy);
  }else {
    router.addRoutes(routerList.normalRoute);
  }
  next({
    ...to,
    replace: true
  });
  next();
}

/**
 * 如琢团购进入个人中心前的授权检查
 */
function handleRzGroupBuyUser(to, next) {
  doFormPost('/userInfo/getUserInfo', null, rs => {
    if (rs.result === 'success') {
      if (rs.userData.myImg.indexOf('defaultHeadImage.png') > 0) {
        wx.miniProgram.navigateTo({
          url: '/pages/index/getUserInfo',
          success: rs => {
            next();
          }
        })
      } else {
        next();
      }
    }
  })
}

router.beforeEach(async (to, from, next) => {
  const token = getToken();

  NProgress.start(); // start progress bar

  // 判断当前 vuex 是否已经具备完整的店铺信息（storeType + brandConfig.shopId）
  // 页面刷新后 vuex 重置，但 brandConfig 已通过 loadBrandConfigFromStorage() 从 localStorage 恢复
  const hasStoreType = !!store.state.app.storeType;
  const hasBrandConfig = !!store.state.app.brandConfig
    && !!store.state.app.brandConfig.shopId;

  if (!hasStoreType) {
    // 1. 首次进入或刷新后 vuex 重置：串行 await storeInfo -> brandConfig，全部完成后再走路由
    const storeUserData = await fetchStoreInfo();
    // 即使 storeUserData 为 null（接口失败），也继续走 brandConfig（可能 localStorage 有缓存）
    await fetchBrandConfig();
    if (storeUserData) {
      proceedRoutes(storeUserData.storeType, to, next);
    }
  } else if (!hasBrandConfig) {
    // 2. storeType 已存在但 brandConfig 缺失：仅补拉品牌配置，完成后再处理路由
    await fetchBrandConfig();
    if (to.path === '/user' && store.getters.storeType === 'rzGroupBuy') {
      handleRzGroupBuyUser(to, next);
    } else {
      next();
    }
  } else {
    // 3. storeType 和 brandConfig 都已就绪：直接走原逻辑
    if (to.path === '/user' && store.getters.storeType === 'rzGroupBuy') {
      handleRzGroupBuyUser(to, next);
    } else {
      next();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});



// WEBPACK FOOTER //
// ./src/permission.js